import gql from 'graphql-tag'

export default gql`query races($filter: FilterFindManyRaceInput, $limit: Int, $skip: Int ) {
  races(filter: $filter, limit: $limit, skip: $skip) {
    _id
    slug
    distance
    distanceUnit
    totalRunDistance
    totalRunDonation
    startTime
    name {
      en
      th
    }
    settings {
      virtualRun {
        donationPerDistance
        period {
          start
          end
        }
      }
    }
    event {
      _id
      slug
      thumbnailUrl
      startDate
      endDate
      name {
        en
        th
      }
      totalRunDistance
      totalRunDonation
    }
  }
}`



// WEBPACK FOOTER //
// ./src/graphql/queries/races.js